import { render, staticRenderFns } from "./CommonWords.vue?vue&type=template&id=100bb229&scoped=true&"
import script from "./CommonWords.vue?vue&type=script&lang=js&"
export * from "./CommonWords.vue?vue&type=script&lang=js&"
import style0 from "./CommonWords.vue?vue&type=style&index=0&id=100bb229&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100bb229",
  null
  
)

export default component.exports